import { api } from './client';

export type SandboxStatus =
  | 'none'
  | 'pending'
  | 'creating'
  | 'ready'
  | 'failed'
  | 'restarting'
  | 'deleting';

export interface ProgressStep {
  status: 'pending' | 'in_progress' | 'completed' | 'failed';
  timestamp?: string;
}

export interface SandboxProgress {
  initializing?: ProgressStep;
  storageAccessPoint?: ProgressStep;
  storageVolumes?: ProgressStep;
  podCreating?: ProgressStep;
  podStarting?: ProgressStep;
  ready?: ProgressStep;
}

export interface SandboxCreateResponse {
  created: boolean;
  status: SandboxStatus;
  message: string;
  sandboxUrl: string;
  requestId?: string;
  progress?: SandboxProgress;
}

export interface SandboxStatusResponse {
  status: SandboxStatus;
  sandboxUrl: string;
  requestedAt?: string;
  readyAt?: string;
  error?: string;
  podName?: string;
  progress?: SandboxProgress;
}

export interface SandboxRestartResponse {
  restarting: boolean;
  status: SandboxStatus;
  message: string;
  requestId?: string;
}

export async function createSandbox(): Promise<SandboxCreateResponse> {
  return api.post('/api/sandbox/create');
}

export async function getSandboxStatus(): Promise<SandboxStatusResponse> {
  return api.get('/api/sandbox/status');
}

export async function restartSandbox(): Promise<SandboxRestartResponse> {
  return api.post('/api/sandbox/restart');
}
